import React, {
  useState,
  useCallback,
  useEffect,
  ChangeEvent,
} from 'react';
import Grid from '@material-ui/core/Grid';

import Complemento from './Complemento';

import { useToast } from '../../../../../../../hooks/toast';
import { useSimpleProduct } from '../../../../../../../hooks/newSimpleProduct';
import { useRegisterAdded } from '../../../../../../../hooks/registerAdded';

import AcordeaoComplementos from '../AcordeaoComplementos';

import {
  TabWrapper,
  DrawerTabTitle,
  HasComplementoWrapper,
  ButtonAction,
  ComplementosStoredWrapper,
} from '../../../drawer_styles';
import { SubmitButtonWrapper } from '../../../../styles';

const Complementos: React.FC = () => {
  const [hasComplemento, setHasComplemento] = useState('no');
  const [btnEnabled, setBtnEnabled] = useState(false);

  const {
    handleSetDisponibilidadeReleased,
    complemento,
    handleSetDisponibilidadeTabClicked,
  } = useSimpleProduct();

  const { handleSetDrawerWasClosed } = useRegisterAdded();

  useEffect(() => {
    if (complemento[complemento.length - 1]) {
      setHasComplemento('yes');
      setBtnEnabled(true);
    }
  }, [complemento]);

  const { addToast } = useToast();

  const handleRadioBtnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setHasComplemento(e.target.value);

      if (e.target.value === 'no') setBtnEnabled(false);
      else if (e.target.value === 'yes') setBtnEnabled(true);
    },
    [],
  );

  const handleSubmit = useCallback(() => {
    if (!hasComplemento) {
      addToast({
        type: 'error',
        title: 'Informe se o item tem complemento',
      });

      return;
    }

    if (hasComplemento === 'no') handleSetDisponibilidadeReleased(true);
    handleSetDisponibilidadeTabClicked(true);
  }, [
    hasComplemento,
    addToast,
    handleSetDisponibilidadeReleased,
    handleSetDisponibilidadeTabClicked
  ]);

  return (
    <TabWrapper>
      <DrawerTabTitle>
        <h1>Complementos</h1>
        <span>Seu produto tem algum complemento? Adicione aqui :&#41;</span>
      </DrawerTabTitle>

      <div>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <HasComplementoWrapper>
              <div>
                <span>Selecione uma opção:</span>

                <form>
                  <label htmlFor="no_have">
                    <input
                      checked={hasComplemento === 'no'}
                      type="radio"
                      id="no_have"
                      name="has_complemento"
                      value="no"
                      onChange={handleRadioBtnChange}
                    />
                    Não, este produto não tem complemento
                  </label>

                  <label htmlFor="have">
                    <input
                      checked={hasComplemento === 'yes'}
                      type="radio"
                      id="have"
                      name="has_complemento"
                      value="yes"
                      onChange={handleRadioBtnChange}
                    />
                    Sim, este produto tem complemento
                  </label>
                </form>
              </div>
            </HasComplementoWrapper>
          </Grid>

          <Grid item xs={12}>
            <Complemento isEnabled={btnEnabled} />
          </Grid>

          {complemento.length > 0 && (
            <Grid item xs={12}>
              <ComplementosStoredWrapper>
                <h2>Grupos de complementos que compõem esse produto</h2>
              </ComplementosStoredWrapper>

              <AcordeaoComplementos />
            </Grid>
          )}

          <Grid item xs={12}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={() => handleSetDrawerWasClosed(true)}
              >
                Cancelar
              </ButtonAction>

              <ButtonAction
                type="button"
                className="submit"
                onClick={handleSubmit}
              >
                Continuar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </div>
    </TabWrapper>
  );
};

export default Complementos;
